import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFCarbs = {
  carbs: number;
};

export const IBF_CARBS = {
  value: 0x1000,
  name: "IBF_CARBS",
  size: 4,
  parse: (record): IBFCarbs => {
    const carbs = record.nextUInt32LE();
    return {
      carbs,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFCarbs>;
